// Author YuJiaBei
// Date 2021-07-21 10:00:52

import * as model from "@/model/em/maintenance/EmMaMaintenanceScheduleModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmMaMaintenanceSchedule(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_MAINTENANCE_URL,
    })
    .buildStore()
